// trim cuts off the extra infromation
// from format to be be data for the orders
const round = price => Math.round(price * 100) / 100;

const trim = product => {
  const { productId, price, count, uid } = product;

  return {
    price: round(price.current),
    id: `${productId}`,
    quantity: count.current,
    product: trimProduct(product),
    uid,
  };
};

const trimProduct = product => {
  const {
    productId,
    type,
    price,
    name,
    providerData = {},
    customisations = [],
    options = [],
    sku = '',
  } = product;
  const { text } = name;
  const { unit } = price;

  return {
    type,
    price: round(unit),
    name: text,
    id: `${productId}`,
    providerData,
    comboProducts: options.map(trimOption),
    customisations: customisations.map(trimCustomisation),
    sku: `${sku}`,
  };
};

const trimCustomisation = customisation => {
  const {
    productId,
    categoryId,
    name,
    price,
    count,
    providerData,
    default: initial,
  } = customisation;
  const { text } = name;

  return {
    price: round(price.current),
    categoryId: `${categoryId}`,
    name: text,
    providerData,
    productId: `${productId}`,
    quantity: count.current,
    defaultQuantity: count.initial,
    default: initial,
  };
};

const trimOption = option => {
  const { id, name, price, customisations = [], providerData } = option;
  const { text } = name;

  return {
    price: round(price.current),
    id: `${id}`,
    name: text,
    providerData,
    customisations: customisations.map(trimCustomisation),
  };
};

export { trim };
